import useStorageCsat from '../store/useStorageCsat'
import useStorageNps from '../store/useStorageNps'
import Loading from '@repo/ui/loading'
import { Route, Routes } from 'react-router-dom'
import routes from './'
import { lazy, Suspense } from 'react'

const Success = lazy(() => import('../pages/Success'))
const AlreadyRating = lazy(() => import('../pages/AlreadyRating'))
const CsatQuestions = lazy(() => import('../pages/CsatQuestions'))
const NpsRating = lazy(() => import('../pages/NpsRating'))
const Error = lazy(() => import('../pages/Error'))
const InitFeedback = lazy(() => import('../pages/'))

export default function Router() {
  const csatToken = useStorageCsat((param) => param.csatToken)
  const npsToken = useStorageNps((param) => param.npsToken)

  if (csatToken === null && npsToken === null) {
    return <Loading />
  } else {
    return (
      <Routes>
        <Route
          path={routes.home}
          element={
            <Suspense fallback={<Loading />}>
              <InitFeedback />
            </Suspense>
          }
        />
        <Route
          path={routes.nps}
          element={
            <Suspense fallback={<Loading />}>
              <NpsRating />
            </Suspense>
          }
        />
        <Route
          path={routes.csat}
          element={
            <Suspense fallback={<Loading />}>
              <CsatQuestions />
            </Suspense>
          }
        />

        <Route
          path={routes.success}
          element={
            <Suspense fallback={<Loading />}>
              <Success />
            </Suspense>
          }
        />

        <Route
          path={routes.alreadyRating}
          element={
            <Suspense fallback={<Loading />}>
              <AlreadyRating />
            </Suspense>
          }
        />

        <Route
          path={routes.error}
          element={
            <Suspense fallback={<Loading />}>
              <Error />
            </Suspense>
          }
        />
      </Routes>
    )
  }
}

